module.exports = __webpack_public_path__ + "e5e77ceef5237f8c8ce47178fdd9acac.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-regular-italic.ttf
// module id = 89
// module chunks = 0